import React from "react"
import { StyleSheet, View } from "react-native"
import { SkeletonBlock, SkeletonCircle, SkeletonGroup, SkeletonLine } from "./utility/skeleton"
import { MAX_CONTENT_WIDTH } from "./config"

export const DashboardBusinessesSkeleton = ({
  cardsPerRow = 4,
  cardWidth = 250,
}: {
  cardsPerRow?: number
  cardWidth?: number
}): React.ReactElement => {
  const primaryCards = Math.max(2, Math.min(4, cardsPerRow))
  const secondaryCards = Math.max(2, Math.min(4, cardsPerRow))

  return (
    <View style={{ width: "100%" }}>
      <View style={[styles.container, { maxWidth: MAX_CONTENT_WIDTH }]}>
        <SkeletonGroup>
          <SkeletonLine width="65%" height={26} radius={10} />

          {/* Primary businesses row (featured card style) */}
          <View style={{ gap: 10 }}>
            <SkeletonLine width="45%" height={18} radius={8} />
            <View style={styles.row}>
              {new Array(primaryCards).fill(0).map((_, idx) => (
                <View
                  key={idx}
                  style={[styles.primaryCard, { width: cardWidth }]}
                >
                  <SkeletonBlock style={styles.primarySquareImage} radius={8} />
                  <View style={styles.primaryTextContainer}>
                    <View style={styles.valueBadgesRow}>
                      <SkeletonCircle size={24} />
                      <SkeletonCircle size={24} />
                      <SkeletonCircle size={24} />
                    </View>
                    <SkeletonLine width="80%" height={14} radius={8} />
                    <SkeletonLine width="95%" height={12} radius={8} />
                    <SkeletonLine width="70%" height={12} radius={8} />
                  </View>
                </View>
              ))}
            </View>
          </View>

          {/* Secondary businesses row (same card style as primary) */}
          <View style={{ gap: 10 }}>
            <SkeletonLine width="55%" height={18} radius={8} />
            <View style={styles.row}>
              {new Array(secondaryCards).fill(0).map((_, idx) => (
                <View
                  key={idx}
                  style={[styles.primaryCard, { width: cardWidth }]}
                >
                  <SkeletonBlock style={styles.primarySquareImage} radius={8} />
                  <View style={styles.primaryTextContainer}>
                    <View style={styles.valueBadgesRow}>
                      <SkeletonCircle size={24} />
                      <SkeletonCircle size={24} />
                      <SkeletonCircle size={24} />
                    </View>
                    <SkeletonLine width="80%" height={14} radius={8} />
                    <SkeletonLine width="95%" height={12} radius={8} />
                    <SkeletonLine width="70%" height={12} radius={8} />
                  </View>
                </View>
              ))}
            </View>
          </View>
        </SkeletonGroup>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignSelf: "center",
    width: "100%",
    paddingHorizontal: 16,
    gap: 12,
  },
  row: {
    flexDirection: "row",
    gap: 10,
    overflow: "hidden",
  },
  primaryCard: {
    borderRadius: 8,
    overflow: "hidden",
  },
  primarySquareImage: {
    width: "100%",
    aspectRatio: 1,
  },
  primaryTextContainer: {
    width: "100%",
    paddingTop: 12,
    paddingBottom: 20,
    paddingHorizontal: 16,
    flexDirection: "column",
    gap: 8,
  },
  valueBadgesRow: {
    height: 24,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
})

